import React, { useRef } from 'react';
import Navbar from '../components/Navbar';
import Header from '../components/HomeHeader';
import Testimonials from '../components/Testimonials';
import Pricing from '../components/HomePricing';
import Footer from '../components/Footer';
import FAQ from '../components/FAQ';
import Register from './Register';
import axios from 'axios';
import Visualizer from '../components/Visualizer';

const Home = () => {

  const queryParams = new URLSearchParams(window.location.search);
  const r = queryParams.get('r');
  const ttclid = queryParams.get('ttclid');
  // Save referral code and ttclid as cookies if present
  React.useEffect(() => {
   if (r) {
  if (window.location.hostname === 'localhost') {
    document.cookie = `affiliate=${r};path=/;max-age=${60 * 60 * 24 * 30};SameSite=Lax`;
  } else {
    document.cookie = `affiliate=${r};path=/;domain=.viralgpt.com;max-age=${60 * 60 * 24 * 30};Secure;SameSite=None`;
  }
}

if (ttclid) {
  if (window.location.hostname === 'localhost') {
    document.cookie = `ttclid=${ttclid};path=/;max-age=${60 * 60 * 24 * 30};SameSite=Lax`;
  } else {
    document.cookie = `ttclid=${ttclid};path=/;domain=.viralgpt.com;max-age=${60 * 60 * 24 * 30};Secure;SameSite=None`;
  }
}


	if (!ttclid) {
		return;
	}

    // Send pixel data to API
    const pixelData = {
      event: 'home_view'
    }
    axios.post('https://api.viralgpt.com/pixel', pixelData, {
      withCredentials: true
    })
      .catch(err => console.error('Error sending pixel data:', err));

  }, [r, ttclid]);
  return (
    <div>
      <Navbar />
      <Header />
	  <Visualizer />
      <Testimonials />
		<hr/>
      <Pricing />
	  <hr/>
	  <FAQ />
	  
      <Footer />

    </div>
	
  );
};

export default Home;
